import type { WorldObjectAPI } from "../../../render/world/WorldObject";
import type { BoardUpdate } from "./BoardUpdate";

export interface BoardWorldObject extends WorldObjectAPI {
  // NOTE: starts any response to a board update, such as piece moves and animations
  onBoardUpdate(boardUpdate: BoardUpdate): void;
  isBoardUpdateFinished(): boolean;
}

export function isBoardWorldObject(
  worldObject: WorldObjectAPI
): worldObject is BoardWorldObject {
  return "onBoardUpdate" in worldObject;
}
